<template lang="pug">
modal#show-envelope-signer-done-modal(
  :no-footer='isPublic && !isBradescoVersion'
  :process-button-label='$t("modal.showEnvelopeSignerDoneModal.processButtonLabel")'
  :showCancelButton='false'
  :title='$t("modal.showEnvelopeSignerDoneModal.title")'
  @closed='closeModal'
  @process='showEnvelopeDetails'
  ref='modal'
  size='sm'
)
  template
    .inner-content
      p.justify-content {{ $t('modal.showEnvelopeSignerDoneModal.message') }}
      p.justify-content {{ $t('modal.showEnvelopeSignerDoneModal.message2') }}
    .text-center.my-4
      img.img-fluid(src='/img/ilustrations/envelope-done.svg')
    div(v-if='isPublic && !isBradescoVersion')
      buttons-login-and-create-account.mt-5
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import ButtonsLoginAndCreateAccount from '@/modules/business/components/molecules/ButtonsLoginAndCreateAccount.vue';
import ApplicationService from '@/services/ApplicationService';

export default {
  name: 'showEnvelopeSignerDoneModal',
  components: {
    Modal,
    ButtonsLoginAndCreateAccount,
  },
  props: {
    isPublic: {
      type: Boolean,
      default: false,
    },
    envelopeId: {
      type: String,
      default: '',
    },
    routeName: {
      type: String,
      default: 'business.documents.inbox',
    },
  },
  computed: {
    closeButtonLabel() {
      return this.isPublic && !this.isBradescoVersion
        ? ''
        : this.$t('button.ok');
    },
    isBradescoVersion() {
      return ApplicationService.isSelfRegistrationBlock();
    },
  },
  methods: {
    showEnvelopeDetails() {
      this.$router.push({ name: this.routeName });
    },
    closeModal() {
      this.$refs.modal.close();
    },
  },
};
</script>
